// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"152016b6","187":"f6a0b621","453":"eb802620","536":"e9c73093","688":"36280882","805":"726eeb50","951":"db416ba9"}[chunkId] + ".chunk.js";
};